<div class="container-fluid pt-5 pb-5">
    <div class="d-flex flex-row bd-highlight"> 
      <div class="pt-5 col-xl-4 col-lg-6 col-md-8 col-sm-10 mx-xl-auto mx-lg-auto mx-md-auto mx-sm-auto content-main">
        <div class="card mx-auto border-0 shadow-lg rounded">
          <img [src]="coverPhoto" class="card-img-top img-cover" alt="...">
          <div class="p-2 mb-3">
            <h2 class="mb-3">Edit Profile</h2>
            <br/>
            <p>Enter your updated details and click Update.</p>
            <mat-spinner *ngIf=showSpinner></mat-spinner>
            <form [formGroup]="updateProfileForm" (ngSubmit)="updateProfile(updateProfileForm.value)">          
              <label>First Name(s):</label>
              <input type="text" 
              [ngModel]="(user | async)?.name" 
              [formControlName]="'name'"
              placeholder="First Name"/>
              <label>Last Name:</label>
              <input type="text"
              [ngModel]="(user | async)?.nameLast" 
              [formControlName]="'nameLast'" 
              placeholder="Last Name"/>
              <label>Mobile Number:</label>
              <input type="text"
              [ngModel]="(user | async)?.phoneNumber" 
              [formControlName]="'phoneNumber'" 
              placeholder="Mobile"/>
              <button type="submit" class="btn btn-primary btn-block">Update</button>
            </form>
            <h3 class="mt-3"></h3>
            <button class="btn btn-dark btn-block" (click)="routeToPeopleDetailsPage()">Cancel</button>        
          </div>
        </div>
      </div>
    </div>
  </div>
  